import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { defaultFieldValues } from 'components/dashboard/signup-generator-content/SignupGeneratorAppearence/fieldDecorator';
import previewTermsDecorator from 'components/dashboard/signup-generator-content/SignupGeneratorAppearence/previewTermsDecorator';

import SignupGeneratorTermsSwitcher from 'components/dashboard/signup-generator-content/SignupGeneratorTermsSwitcher';
import SignupGeneratorField from 'components/dashboard/signup-generator-content/SignupGeneratorField';

import './SignupGeneratorTerms.css';

const SignupGeneratorTerms = ({ signupGenerator }) => {
  const { t } = useTranslation();
  const [isCustomTerms, setCustomTerms] = useState(signupGenerator.is_custom_tc || false);
  const [termsBtnText, setTermsBtnText] = useState(signupGenerator.tc_url_text || null);
  const [termsUrl, setTermsUrl] = useState(signupGenerator.tc_url || null);

  return (
    <div className="email-signup-generator-terms__component">
      <div className="email-signup-generator-terms-wrapper">
        <SignupGeneratorTermsSwitcher
          value={isCustomTerms} // needed for change value
          checked={isCustomTerms} // needed to show changed value
          onChange={(_e, { value }) => { setCustomTerms(!value); }}
          name="is_custom_tc"
          noClickOutside
        />

        {signupGenerator && signupGenerator.is_custom_tc &&

          <div className="email-signup-generator-terms-content">
            <SignupGeneratorField
              value={termsBtnText}
              onChange={(e) => {
                e.preventDefault();
                setTermsBtnText(e.target.value);
              }}
              placeholder={defaultFieldValues.tc_url_text}
              fieldLabel={t("Label")}
              name="tc_url_text"
            />

            <SignupGeneratorField
              value={termsUrl}
              onChange={(e) => {
                e.preventDefault();
                setTermsUrl(e.target.value);
              }}
              placeholder={defaultFieldValues.tc_url}
              fieldLabel={t("Terms URL")}
              name="tc_url"
            />
          </div>
        }
      </div>
    </div>
  );
};

SignupGeneratorTerms.propTypes = {
  signupGenerator: PropTypes.object,
};
SignupGeneratorTerms.defaultProps = {
  signupGenerator: null,
};

export default previewTermsDecorator(SignupGeneratorTerms);
